import { ThemeProperties } from "../../../Theme/ThemeProperties"
const Tabs = [
    {
        id:1,
        name:"Warranty Claims",
        color:ThemeProperties.red_400
    }
]

export default Tabs